(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["akwatix-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('akwatix-products')) {
    customElements.define('akwatix-products', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) { this.observer?.observe(this.querySelector('.akw-products')); return; }
        this.ready = true;
        const track = this.querySelector('.akw-products');
        const controls = this.querySelector('.akw-slider-controls');
        const buttons = [...controls.querySelectorAll('button')];
        const sync = () => {
          controls.hidden = track.scrollWidth <= track.clientWidth + 2;
          buttons[0].disabled = track.scrollLeft < 2;
          buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = track.firstElementChild;
          if (!card) return;
          const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          track.scrollBy({ left: distance * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }));
        track.addEventListener('scroll', sync, { passive: true });
        this.observer = new ResizeObserver(sync);
        this.observer.observe(track);
        sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  if (!customElements.get('akwatix-paths')) {
    customElements.define('akwatix-paths', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const list = this.querySelector('.akw-path-tabs');
        const buttons = [...list.querySelectorAll('button')];
        const panels = [...this.querySelectorAll('[data-panel]')];
        list.hidden = false;
        list.setAttribute('role', 'tablist');
        panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
        const select = button => {
          buttons.forEach(item => { item.setAttribute('aria-selected', String(item === button)); item.tabIndex = item === button ? 0 : -1; });
          panels.forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.path; });
        };
        buttons.forEach((button, index) => {
          button.setAttribute('role', 'tab');
          button.addEventListener('click', () => {
            if (button.getAttribute('aria-selected') === 'true') return;
            if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(() => select(button));
            else select(button);
          });
          button.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = buttons.length - 1;
            if (next === undefined) return;
            event.preventDefault(); buttons[next].focus(); select(buttons[next]);
          });
        });
        select(buttons[0]);
      }
    });
  }
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); reveal.unobserve(entry.target); }
    }), { threshold: .08 });
    document.querySelectorAll('.akw-reveal').forEach(section => reveal.observe(section));
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["akwatix-purchase-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('akwatix-size-link')) {
    customElements.define('akwatix-size-link', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          if (!link) return;
          const description = document.getElementById(link.hash.slice(1));
          if (!description) return;
          const heading = [...description.querySelectorAll('h2, h3, h4, strong, b')].find((item) => /size\s+(guide|chart)|guide\s+des\s+tailles|charte\s+de\s+grandeur/i.test(item.textContent));
          if (!heading) return;
          const table = [...description.querySelectorAll('table')].find((item) => heading.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING);
          if (table && typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function') {
            if (!this.dialog) {
              const range = document.createRange();
              range.setStartBefore(heading);
              range.setEndAfter(table);
              const content = document.createElement('div');
              content.className = 'akwatix-size-dialog__content rte';
              content.append(range.cloneContents());
              content.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id'));
              content.querySelectorAll('table').forEach((item) => {
                const wrapper = document.createElement('div');
                wrapper.className = 'akwatix-size-dialog__table';
                item.before(wrapper);
                wrapper.append(item);
              });
              const dialog = document.createElement('dialog');
              dialog.className = 'akwatix-size-dialog';
              dialog.setAttribute('aria-label', heading.textContent.trim());
              const bar = document.createElement('div');
              bar.className = 'akwatix-size-dialog__bar';
              const close = document.createElement('button');
              close.type = 'button';
              close.className = 'akwatix-size-dialog__close';
              close.textContent = this.dataset.closeLabel;
              close.addEventListener('click', () => dialog.close());
              dialog.addEventListener('close', () => link.focus({ preventScroll: true }));
              bar.append(close);
              dialog.append(bar, content);
              document.body.append(dialog);
              this.dialog = dialog;
              link.setAttribute('aria-haspopup', 'dialog');
            }
            event.preventDefault();
            this.dialog.showModal();
            return;
          }
          event.preventDefault();
          const disclosure = heading.closest('details');
          if (disclosure) disclosure.open = true;
          heading.id ||= description.id.replace('AkwatixDescription-', 'AkwatixSizeGuide-');
          heading.setAttribute('tabindex', '-1');
          heading.scrollIntoView({ block: 'start', behavior: 'instant' });
          heading.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        this.dialog?.remove();
        this.dialog = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
